import {Component, OnInit} from '@angular/core';
import {GroupColumn} from '../../_models/OrdiniGroupColumns';
import {ModalController, ToastController} from '@ionic/angular';
import {AccountOrganizzazione} from '../../_models/AccountOrganizzazione';
import {SaveMessage} from '../../_helpers/save-message';
import {OrganizzazioniService} from '../../_services/organizzazioni.service';

@Component({
  selector: 'app-ordini-vendita-group-columns',
  templateUrl: './ordini-vendita-group-columns.component.html',
  styleUrls: ['./ordini-vendita-group-columns.component.scss'],
  standalone: false
})
export class OrdiniVenditaGroupColumnsComponent implements OnInit {
  columns: GroupColumn[] = [];
  accountOrganizzazione: AccountOrganizzazione;
  loading = false;

  get activeCount(): number {
    return this.columns.filter(c => c.active).length;
  }

  isToggleDisabled(column: GroupColumn): boolean {
    return !column.active && this.activeCount >= 3;
  }

  constructor(
    private saveMessage: SaveMessage,
    private organizzazioniService: OrganizzazioniService,
    private modalCtrl: ModalController,
    private toastCtrl: ToastController
  ) {}

  ngOnInit() {
    this.columns = this.organizzazioniService.venditaGroupColumns
      .sort((a, b) => a.order - b.order);
    this.accountOrganizzazione = this.organizzazioniService.currentAccountSettingsSubject.value;
  }

  cancel = () => this.modalCtrl.dismiss(false, 'cancel');

  async onToggleChange(column: GroupColumn, activated: boolean) {
    // Disattivazione: scarta la direzione scelta, così una riattivazione (anche nella
    // stessa sessione) riparte dal default crescente (FR-013).
    if (!activated) {
      column.sortAsc = true;
      return;
    }
    if (activated && this.activeCount >= 3) {
      column.active = false;
      const toast = await this.toastCtrl.create({
        message: 'Limite massimo di 3 livelli raggiunto',
        duration: 2000,
        color: 'warning',
        position: 'top'
      });
      await toast.present();
    }
  }

  toggleSort(column: GroupColumn): void {
    if (column.active) {
      column.sortAsc = !column.sortAsc;
    }
  }

  handleReorder(ev: CustomEvent) {
    this.columns = ev.detail.complete(this.columns);
  }

  resetDefault() {
    this.loading = true;
    this.accountOrganizzazione.groupColumnsOrdiniCliente = null;
    this.organizzazioniService.saveAccountOrganizzazioneAsync(this.accountOrganizzazione)
      .then((_acc: AccountOrganizzazione) => {
        this.organizzazioniService.setCurrentAccountSettingsValue(_acc);
        this.modalCtrl.dismiss(true, 'confirm');
      })
      .catch(() => this.saveMessage.messageError('Ci sono problemi con il salvataggio.'))
      .finally(() => this.loading = false);
  }

  succesSave() {
    this.loading = true;
    const activeColumns = this.columns
      .filter(c => c.active)
      .map(c => c.columnName + (c.sortAsc ? '<' : '>'));
    this.accountOrganizzazione.groupColumnsOrdiniCliente = activeColumns.length > 0
      ? activeColumns.join(',')
      : null;
    this.organizzazioniService.saveAccountOrganizzazioneAsync(this.accountOrganizzazione)
      .then((_acc: AccountOrganizzazione) => {
        this.organizzazioniService.setCurrentAccountSettingsValue(_acc);
        this.modalCtrl.dismiss(true, 'confirm');
      })
      .catch(() => this.saveMessage.messageError('Ci sono problemi con il salvataggio.'))
      .finally(() => this.loading = false);
  }
}
